module.exports = __webpack_public_path__ + "img/p_25.4308ead9.png";